import { render, staticRenderFns } from "./Hood_work.vue?vue&type=template&id=512a9505&"
import script from "./Hood_work.vue?vue&type=script&lang=js&"
export * from "./Hood_work.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports